import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";

interface IndexParcelTemplatesProviderProps {
  children: ReactNode;
  callback?: () => void;
}

interface IndexParcelTemplatesContextValue {
  modalConfig: ModalConfig;
  setModalConfig: Dispatch<SetStateAction<ModalConfig>>;
  callback?: () => void;
}

const IndexParcelTemplatesContext = createContext<
  IndexParcelTemplatesContextValue | undefined
>(undefined);

const IndexParcelTemplatesProvider: React.FC<
  IndexParcelTemplatesProviderProps
> = ({ children, callback }) => {
  const [modalConfig, setModalConfig] = useState<ModalConfig>(
    createModalConfig()
  );

  return (
    <IndexParcelTemplatesContext.Provider
      value={{ modalConfig, setModalConfig, callback }}
    >
      {children}
    </IndexParcelTemplatesContext.Provider>
  );
};

const useIndexParcelTemplatesContext = (): IndexParcelTemplatesContextValue => {
  const context = useContext(IndexParcelTemplatesContext);
  if (!context) {
    throw new Error(
      "useIndexParcelTemplatesContext must be used within an IndexParcelTemplatesProvider"
    );
  }
  return context;
};

export { IndexParcelTemplatesProvider, useIndexParcelTemplatesContext };
